import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CoreModule } from 'src/app/core/core.module';
import { HomeRoutingModule } from './home-routing.module';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DashboardComponent } from './dashboard/dashboard.component';
import { TableModule } from 'primeng/table';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TagModule } from 'primeng/tag';
import { ProcessorComponent } from './processor/processor.component';
import { BadgeModule } from 'primeng/badge';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'primeng/tooltip';
import { CalendarModule } from 'primeng/calendar';
import { ConfirmDialog, ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from "primeng/dialog";
import { MessagesModule } from "primeng/messages";


@NgModule({
  declarations: [    
    DashboardComponent,
    ProcessorComponent
  ],
  imports: [
    CommonModule,
    CoreModule,
    HomeRoutingModule,
    ButtonModule,
    CardModule,
    TableModule,
    OverlayPanelModule,
    TagModule,
    BadgeModule,
    DropdownModule,
    InputTextModule,
    CheckboxModule,
    FormsModule,
    TooltipModule,
    CalendarModule,
    ConfirmDialogModule,
    DialogModule,
    MessagesModule
]
})
export class HomeModule { }
